module.exports = __webpack_public_path__ + "static/media/VIP_2.a8db481f.jpg";